import { render, staticRenderFns } from "./LocalOcorrencia.vue?vue&type=template&id=234fa10c&"
import script from "./LocalOcorrencia.vue?vue&type=script&lang=js&"
export * from "./LocalOcorrencia.vue?vue&type=script&lang=js&"
import style0 from "./LocalOcorrencia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports